import CardGridItemBuilder from "./stories/atoms/CardGridItem/CardGridItem.builder.js";
import ClientLogosBuilder from "./stories/atoms/ClientLogos/ClientLogos.builder.js";
import EditorialTextBuilder from "./stories/atoms/EditorialText/EditorialText.builder.js";
import FlashyBuilder from "./stories/atoms/Flashy/Flashy.builder.js";
import LeadershipBuilder from "./stories/atoms/Leadership/Leadership.builder.js";
import PartnersBuilder from "./stories/atoms/Partners/Partners.builder.js";
import ServicesBuilder from "./stories/atoms/Services/Services.builder.js";
import TextCalloutBuilder from "./stories/atoms/TextCallout/TextCallout.builder.js";
import AuthorBioBuilder from "./stories/molecules/AuthorBio/AuthorBio.builder.js";
import CardGridBuilder from "./stories/molecules/CardGrid/CardGrid.builder.js";
import ContentAndFormBuilder from "./stories/molecules/ContentAndForm/ContentAndForm.builder.js";
import FAQBuilder from "./stories/molecules/FAQ/FAQ.builder.js";
import FeaturedItemsBuilder from "./stories/molecules/FeaturedItems/FeaturedItems.builder.js";
import FeatureSliderBuilder from "./stories/molecules/FeatureSlider/FeatureSlider.builder.js";
import FourColListBuilder from "./stories/molecules/FourColList/FourColList.builder.js";
import HubSpotFormBuilder from "./stories/molecules/HubSpotForm/HubSpotForm.builder.js";
import IframeBuilder from "./stories/molecules/Iframe/Iframe.builder.js";
import MediaAndTextBuilder from "./stories/molecules/MediaAndText/MediaAndText.builder.js";
import MultiColListBuilder from "./stories/molecules/MultiColList/MultiColList.builder.js";
import ServiceCalloutContainerBuilder from "./stories/molecules/ServiceCalloutContainer/ServiceCalloutContainer.builder.js";
import ServiceContactCtaBuilder from "./stories/molecules/ServiceContactCta/ServiceContactCta.builder.js";
import ServiceDividerBuilder from "./stories/molecules/ServiceDivider/ServiceDivider.builder.js";
import ServiceGridBuilder from "./stories/molecules/ServiceGrid/ServiceGrid.builder.js";
import ServiceIntroTextBuilder from "./stories/molecules/ServiceIntroText/ServiceIntroText.builder.js";
import ServicePageSectionBuilder from "./stories/molecules/ServicePageSection/ServicePageSection.builder.js";
import ServiceQuoteCardBuilder from "./stories/molecules/ServiceQuoteCard/ServiceQuoteCard.builder.js";
import ServiceRelatedWorkCardBuilder from "./stories/molecules/ServiceRelatedWorkCard/ServiceRelatedWorkCard.builder.js";
import ServiceResultCardBuilder from "./stories/molecules/ServiceResultCard/ServiceResultCard.builder.js";
import SlideDeckBuilder from "./stories/molecules/SlideDeck/SlideDeck.builder.js";
import StickyCtaBuilder from "./stories/molecules/StickyCta/StickyCta.builder.js";
import TestimonialBuilder from "./stories/molecules/Testimonial/Testimonial.builder.js";
import TitleTextColBuilder from "./stories/molecules/TitleTextCol/TitleTextCol.builder.js";
import HeroBuilder from "./stories/organisms/Hero/Hero.builder.js";

/**
 * @typedef {{
 *   component?: unknown;
 *   name?: string;
 *   inputs?: Array<{ name?: string }>;
 * }} BuilderComponentDefinition
 */

const HIDE_BLOCK_INPUT = {
    friendlyName: "Hide this block",
    name: "hideBlock",
    type: "boolean",
    defaultValue: false,
    helperText: "Hide this block without deleting its content. Hidden blocks are not rendered.",
};

/** @type {{ name?: string }} */
const hideBlockInput = HIDE_BLOCK_INPUT;

/**
 * @param {BuilderComponentDefinition} componentDefinition
 */
function withHideBlockInput(componentDefinition) {
    const existingInputs = Array.isArray(componentDefinition.inputs)
        ? componentDefinition.inputs
        : [];
    const hasHideBlockInput = existingInputs.some((input) => input?.name === hideBlockInput.name);

    if (hasHideBlockInput) {
        return componentDefinition;
    }

    return {
        ...componentDefinition,
        inputs: [...existingInputs, hideBlockInput],
    };
}

/** @type {BuilderComponentDefinition[]} */
const BASE_CUSTOM_COMPONENTS = [
    AuthorBioBuilder,
    CardGridBuilder,
    CardGridItemBuilder,
    ClientLogosBuilder,
    EditorialTextBuilder,
    FAQBuilder,
    FeaturedItemsBuilder,
    FeatureSliderBuilder,
    FlashyBuilder,
    FourColListBuilder,
    HeroBuilder,
    HubSpotFormBuilder,
    MediaAndTextBuilder,
    MultiColListBuilder,
    LeadershipBuilder,
    PartnersBuilder,
    ServiceCalloutContainerBuilder,
    ServiceContactCtaBuilder,
    ServiceDividerBuilder,
    ServiceGridBuilder,
    ServiceIntroTextBuilder,
    ServicePageSectionBuilder,
    ServiceQuoteCardBuilder,
    ServiceRelatedWorkCardBuilder,
    ServiceResultCardBuilder,
    ServicesBuilder,
    SlideDeckBuilder,
    TestimonialBuilder,
    TextCalloutBuilder,
    StickyCtaBuilder,
    IframeBuilder,
    ContentAndFormBuilder,
    TitleTextColBuilder,
];

export const CUSTOM_COMPONENTS = BASE_CUSTOM_COMPONENTS.map(withHideBlockInput);
